import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  accordion: {
    border: `1px solid ${theme.palette.primary.main}`,
    '&.MuiAccordion-rounded': {
      borderRadius: 10,
    },
    '&.MuiAccordion-root:before': {
      height: 0,
    },
    '&.MuiAccordion-root.Mui-expanded': {
      margin: 0,
    },
  },
  accordionDetails: {
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    '&.MuiAccordionSummary-root.Mui-expanded': {
      height: 58,
    },
    '&.MuiAccordionSummary-root': {
      height: 58,
    },
  },
  details: {
    '&.MuiAccordionDetails-root': {
      padding: 32,
    },
  },
}));

const ProductCollapseSkeleton = ({ ...props }) => {
  const classes = useStyles();
  return (
    <Accordion className={classes.accordion} elevation={0} expanded={true}>
      <AccordionSummary
        className={classes.accordionDetails}
        expandIcon={<ExpandMoreIcon />}
      >
        <Skeleton width={'100%'} />
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        {props.children}{' '}
      </AccordionDetails>
    </Accordion>
  );
};

ProductCollapseSkeleton.propTypes = {
  children: PropTypes.node,
};

export default ProductCollapseSkeleton;
